<template>
  <div class="fd-xyjj">
    <el-row :gutter="21">
      <!-- <el-col :span="4">
        <leftMenu :menuList="menuList" :path='$router.currentRoute.path'></leftMenu>
      </el-col> -->
      <el-col :span="24" style="min-height:800px">
        <div class="fd-content-bg">
          <h3 style="margin-bottom:14px;font-size:28px;font-family: SimHei,serif !important;">{{title}}</h3>
          <div>
            <span class="author" v-if="author != null">作者:{{author }} | </span>
            <span class="author" v-if="source != null">来源:{{ source }} | </span>
            <span class="author" v-if="publishDate != null">时间:{{ publishDate }}</span>
            <!-- <span class="author" v-if="sumHits != null">点击量：{{ sumHits }}</span> -->
          </div>
          <br>
          <div v-html="content" style="text-align:left" class="fd-content"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import leftMenu from '../components/leftMenu.vue';
export default {
  components: {
    leftMenu,
  },
  data() {
    return {
      columnCode: '',
      menuList: [],
      content: '',
      imgSrc: 'assets/images/位图.png',
      title: '',
    };
  },
  created() {
    this.columnCode = this.$route.query.columnCode;
    // let menuList = this.$route.query.menuList;
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.getContent();
  },
  mounted() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  },
  methods: {
    getContent() {
      const rangeType = {
        columnCode: this.columnCode,
      };
      this.axios.post(
        `/api/v1/portal/secondary/gd`,
        {...rangeType},
        {},
        (resp) => {
          if (resp && resp.status === 200) {
            this.content = resp.data[0].content;
            this.title = resp.data[0].title;
            this.author = resp.data[0].f22;
            this.source = resp.data[0].source;
            this.publishDate = resp.data[0].publishDate;
            this.sumHits = resp.data[0].sumHits;
          }
        },
        // (error) => {
        //   console.error(error);
        //   this.$message({
        //     type: "error",
        //     message: "查询失败",
        //   });
        // }
      );
    },
  },
};
</script>
<style>
.fd-content p img {
  margin: 15px auto;
  max-width: 100%;
  display: block;
}
.fd-content p {
  word-break: break-all;
  margin: 15px auto;
  text-indent: 2em;
  font-size: 16px !important;
  line-height: 30px;
  color: #000 !important;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei UI,
    Microsoft YaHei, Source Han Sans CN, sans-serif !important;
}

.fd-content p span {
  font-size: 16px !important;
  color: #000 !important;
  line-height: 30px;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei UI,
    Microsoft YaHei, Source Han Sans CN, sans-serif !important;
}

.fd-content p iframe {
  margin: 15px auto;
  display: block;
}

.fd-content div span {
  font-size: 16px !important;
  line-height: 30px !important;
  color: #000 !important;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei UI,
    Microsoft YaHei, Source Han Sans CN, sans-serif !important;
}
.author {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/page/xyjj.vue